import React from 'react'
import ModalsController from './../shared/Modals.controller'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import {
  MDBBtn,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MAndARequestForm from './../../newhome/RequestForm.manda'

import './MAndARequestModal.component.scss'

const MODAL_ID = 'modals.manda-request',
  MODAL_BODY_CLASS = 'manda-modal-open'

class MAndARequestModal extends React.Component {
  state = {
    isLoading: false,
    isOpen: false,
  }

  _ = null

  _open = () => this.setState({ isOpen: true })

  _isOpen = () => this.state.isOpen === true

  _isAutoOpen = () => this._.params(MODAL_ID, 'autoOpen') !== false

  // _toggle = () => {
  //   const isOpen = !this.state.isOpen
  //   try {
  //     if (isOpen) this._.checkCanOpen(MODAL_ID)
  //     this._[isOpen ? 'open' : 'close'](MODAL_ID)
  //   } catch (ex) {
  //     return false
  //   }
  //   this.setState({ isOpen })
  // }

  _close = () => {
    if (typeof this.props?.onClose === 'function') this.props.onClose()
  }

  componentDidMount() {
    this._ = ModalsController.init(MODAL_ID, {
      autoOpen: !isNaN(this.props?.autoOpen) && this.props.autoOpen > 0 ? parseInt(this.props.autoOpen) : false,
      bodyClass: MODAL_BODY_CLASS,
    })
  }

  // componentDidUpdate() {
  //   if (!this._isOpen() && this.props.isOpen && this._ && !this._isAutoOpen())
  //     this._toggle()
  // }

  componentWillUnmount() {}

  render() {
    return (
      <MDBModal open={this.props.isOpen} onClose={this._close} id='MAndARequestModalComponent' disablebackdrop={'true'}>
        <MDBModalDialog size='lg'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                Get More Info!<MDBBtn type='button' className='btn-close' color='none' onClick={this._close}></MDBBtn>
              </MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className={this.state.isLoading ? 'is-loading' : ''}>
              {this.state.isLoading ? (
                <div className='loading-wrapper'>
                  <LoadingSpinner size='md' isActive={true} />
                </div>
              ) : (
                <>
                  <div>
                    <MAndARequestForm onSuccess={() => this._close()} />
                  </div>
                </>
              )}
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    )
  }
}

export default MAndARequestModal
